/**
 * reCAPTCHA Configuration
 * 
 * IMPORTANT: You must set up your own reCAPTCHA keys to remove the testing message!
 * 
 * To get your reCAPTCHA keys:
 * 1. Go to https://www.google.com/recaptcha/admin/create
 * 2. Choose reCAPTCHA v2 "I'm not a robot" Checkbox
 * 3. Add your domain (your actual domain for production)
 * 4. Get your Site Key and Secret Key
 * 5. Create a .env file in the root directory with:
 *    REACT_APP_RECAPTCHA_SITE_KEY=your_actual_site_key
 *    REACT_APP_RECAPTCHA_SECRET_KEY=your_actual_secret_key
 * 
 * The current keys are Google's test keys and will show "This reCAPTCHA is for testing purposes only"
 */

const recaptchaConfig = {
  // PRODUCTION: Use your actual reCAPTCHA site key
  siteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY || '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI', // TEST KEY - REPLACE!
  
  // Note: Secret key should be stored on your backend server, not in frontend code
  // This is just for reference - use it in your backend API
  secretKey: process.env.REACT_APP_RECAPTCHA_SECRET_KEY || '6LeIxAcTAAAAAGG-vFI1TnRWxMZNFuojJ4WifJWe', // TEST SECRET - REPLACE!
};

export default recaptchaConfig;
